import type * as SchemaTypes from '../../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitSocResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitSocResultInput;
}>;


export type SubmitSocResultMutation = (
  { __typename: 'Mutation' }
  & { submitSocResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'SubmitSocResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & SocAssessmentResultFragment
    )> }
  ) }
);

export type SocAssessmentResultFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'companyId' | 'userId' | 'moduleInstanceId' | 'courseInstanceId' | 'assessmentRunId' | 'createdAt' | 'completedAt' | 'updatedAt' | 'updatedBy' | 'isDeleted'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'role' | 'email'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, courseInstance?: SchemaTypes.Maybe<(
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'name'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'BmpResult' } | { __typename: 'CardioRespResult' } | { __typename: 'FinSwimResult' } | { __typename: 'IpptResult' } | { __typename: 'ML360Result' } | { __typename: 'March20kmResult' } | { __typename: 'SartResult' } | { __typename: 'SelfDeterminationResult' } | (
    { __typename: 'SocResult' }
    & SocAssessmentResultDataFragment
  ) | { __typename: 'SpatialPlanningResult' } | { __typename: 'StrengthResult' } | { __typename: 'TeamResilienceResult' } | { __typename: 'TrainersNotesResult' } | { __typename: 'VisualReactionResult' } | { __typename: 'WeightResult' } }
);

export type SocAssessmentResultDataFragment = (
  { __typename: 'SocResult' }
  & Pick<SchemaTypes.SocResult, 'timingSec' | 'result'>
);

export const SocAssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment SocAssessmentResultData on SocResult {
  timingSec
  result
}
    `;
export const SocAssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment SocAssessmentResult on AssessmentResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      role
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  moduleInstanceId
  moduleInstance {
    name
  }
  courseInstanceId
  courseInstance {
    name
  }
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on SocResult {
      ...SocAssessmentResultData
    }
  }
  createdAt
  completedAt
  updatedAt
  updatedBy
  isDeleted
}
    `;
export const SubmitSocResultDocument = /*#__PURE__*/ gql`
    mutation SubmitSocResult($input: SubmitSocResultInput!) {
  submitSocResult(input: $input) {
    ... on SubmitSocResultSuccessfulResponse {
      result {
        ...SocAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${SocAssessmentResultFragmentDoc}
${SocAssessmentResultDataFragmentDoc}`;
export type SubmitSocResultMutationFn = Apollo.MutationFunction<SubmitSocResultMutation, SubmitSocResultMutationVariables>;

/**
 * __useSubmitSocResultMutation__
 *
 * To run a mutation, you first call `useSubmitSocResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSocResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSocResultMutation, { data, loading, error }] = useSubmitSocResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitSocResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSocResultMutation, SubmitSocResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSocResultMutation, SubmitSocResultMutationVariables>(SubmitSocResultDocument, options);
      }
export type SubmitSocResultMutationHookResult = ReturnType<typeof useSubmitSocResultMutation>;
export type SubmitSocResultMutationResult = Apollo.MutationResult<SubmitSocResultMutation>;
export type SubmitSocResultMutationOptions = Apollo.BaseMutationOptions<SubmitSocResultMutation, SubmitSocResultMutationVariables>;